import React, { useRef } from 'react'
import { useSelector } from 'react-redux'

import Avatar from 'components/common/Avatar'
import { useEmoji, useGesture, useGiphy } from 'components/Tiles/hooks'
import { ids } from 'constants/elementIdentifiers'
import { userTypes } from 'constants/user'
import { isEmpty } from 'helpers/lodash'
import { isDemo } from 'helpers/miscellaneous'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { SECONDARY_DEVICE } from 'services/webSockets/roomState/constants'
import {
    _isIframeShared,
    _roomStateMsgData,
    _websocketNoteMsg,
    _websocketUserId,
} from 'store/selectors/WebSocket'
import { isDesktop } from 'utils/device'

import {
    RectangleOuter,
    RectangleInner,
    TileWrapper,
    Indicators,
    ReactionWrapper,
    NoteContainer,
} from './styles'

import Audio from '../../AudioLevelIndicator/AudioLevelIndicator'
import { Gesture } from '../components'
import { Emoji } from '../components/Emoji'
import { Giphy } from '../components/Giphy'
import Network from '../Indicators/Network'
import Note from '../Indicators/Note'
import FoodButton from '../Modes/Greetings/FoodButton'
import FoodSplotch from '../Modes/Greetings/FoodSplotch'
import LetsVibe from '../Modes/LetsVibe'
import { MobileTeacherWrapper, AvatarWrapper } from '../styles'
const Teacher = ({
    isLocal,
    identity,
    audioTrack,
    children,
    studentsCount,
    isVideoEnabled,
    isActiveSpeaker,
}) => {
    let tile = useRef(null)

    const { userType } = useVideoContext()
    const notes = useSelector(_websocketNoteMsg)
    const userId = useSelector(_websocketUserId)

    const iframeShared = useSelector(_isIframeShared)

    const emojiData = useEmoji(isLocal, identity)
    const giphyData = useGiphy(isLocal, identity)
    const gestureData = useGesture(isLocal, identity)

    const data = useSelector(_roomStateMsgData)

    const userNotes = React.useMemo(() => {
        return isDemo && userId
            ? notes.filter(note => {
                  return note.note.user_id === userId
              })
            : notes.filter(note => {
                  return note.note.user_id === identity.uuid
              })
    }, [notes, userId])

    const isTeacher = userType === userTypes.TEACHER

    const isSecondaryDevice = data === SECONDARY_DEVICE && isTeacher

    console.count('Teacher Component')

    const vibeProps = {
        isLocal,
        teacher: true,
        uuid: identity?.uuid,
    }

    const greetingsProps = {
        ...vibeProps,
    }

    if (!isDesktop) {
        return (
            <MobileTeacherWrapper>
                {children}
                {!isVideoEnabled && <Avatar userType={userTypes.TEACHER} />}
            </MobileTeacherWrapper>
        )
    }

    const indicators = (
        <Indicators>
            <Network isTeacher />

            <Audio
                identity={identity}
                isLocal={isLocal}
                audioTrack={audioTrack}
                background="white"
                iconWidth={studentsCount < 2 ? '' : 12}
            />
        </Indicators>
    )

    return (
        <RectangleOuter>
            <RectangleInner
                isActiveSpeaker={isActiveSpeaker}
                iframeShared={iframeShared}
                studentsCount={studentsCount}
                ref={tile}
                id={`${ids.TILE_PREFIX}${identity?.uuid}`}
                isSecondaryDevice={isSecondaryDevice}
            >
                <TileWrapper isSpeaking={isActiveSpeaker}>
                    <AvatarWrapper>
                        <Avatar userType={userTypes.TEACHER} />
                    </AvatarWrapper>
                    {children}
                    {emojiData.show ? (
                        <ReactionWrapper>
                            <Emoji isTeacher emoji={emojiData.id} />
                        </ReactionWrapper>
                    ) : null}
                    {giphyData.show ? (
                        <ReactionWrapper isGiphy>
                            <Giphy gifId={giphyData.id} />
                        </ReactionWrapper>
                    ) : null}

                    <ReactionWrapper>
                        <Gesture
                            visible={gestureData.show}
                            gestureKey={gestureData.gestureKey}
                            gestureType={gestureData.gestureType}
                            gesturePK={gestureData.gesturePK}
                            isLocal={isLocal}
                        />
                    </ReactionWrapper>
                </TileWrapper>

                <FoodSplotch {...greetingsProps} />

                {!isEmpty(userNotes) ? (
                    <NoteContainer>
                        <Note
                            studentsCount={studentsCount}
                            userNotes={userNotes}
                            isTeacher={isTeacher}
                            userId={identity.uuid}
                            userName={identity.fullName}
                        />
                    </NoteContainer>
                ) : null}
                <FoodButton {...greetingsProps} />
                <LetsVibe
                    alternate={indicators}
                    {...vibeProps}
                    id={`vibe-${identity.uuid}`}
                />
            </RectangleInner>
        </RectangleOuter>
    )
}

export default Teacher
